// extracted by mini-css-extract-plugin
export default {"containerDate":"BirthdayInput_containerDate__6QgRm"};